import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { normalizeEntitlementRecord } from './contentPackAccess';
import { notifyEntitlementRevoked } from './notifications';

export function getOrganizationEntitlements(entitlements = [], organizationId = '') {
  return (entitlements || [])
    .map((entitlement) => normalizeEntitlementRecord(entitlement))
    .filter((entitlement) => entitlement.organizationId === organizationId);
}

export function getContentPackEntitledOrganizations(entitlements = [], contentPackId = '') {
  return (entitlements || [])
    .map((entitlement) => normalizeEntitlementRecord(entitlement))
    .filter((entitlement) => entitlement.contentPackId === contentPackId);
}

export async function revokeOrganizationEntitlement(
  db,
  {
    entitlementId = '',
    organizationId = '',
    contentPackId = '',
    actorUserId = '',
    actorName = '',
  } = {}
) {
  if (!entitlementId) {
    throw new Error('entitlementId is required');
  }

  await updateDoc(doc(db, 'entitlements', entitlementId), {
    status: 'revoked',
    updatedAt: serverTimestamp(),
  });

  try {
    await notifyEntitlementRevoked(db, {
      organizationId,
      contentPackId,
      actorUserId,
      actorName,
    });
  } catch (error) {
    console.error('Failed to create entitlement revoke notification:', error);
  }
}

export async function updateEntitlementDates(
  db,
  {
    entitlementId = '',
    startDate = null,
    endDate = null,
  } = {}
) {
  if (!entitlementId) {
    throw new Error('entitlementId is required');
  }

  await updateDoc(doc(db, 'entitlements', entitlementId), {
    startDate: startDate || null,
    endDate: endDate || null,
    updatedAt: serverTimestamp(),
  });
}
